import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getTypeHue, tagStyle } from '../theme/statusTokens';

export interface TypeBadgeProps {
  type?: string;
}

/** Deployment type tag (lambda / ecs / terraform / static / adhoc / agentcore-runtime). */
const TypeBadge: React.FC<TypeBadgeProps> = ({ type }) => {
  const theme = useTheme();
  if (!type) return null;
  const style = tagStyle(getTypeHue(type), theme.palette.mode);
  return (
    <Chip
      label={type}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.text,
        border: `1px solid ${style.border}`,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: 20,
        '& .MuiChip-label': { px: 0.9 },
      }}
    />
  );
};

export default TypeBadge;
